import React from "react";
import { motion } from "framer-motion";
import Select from "react-select";

function Contact() {
  
  
  const fadeInDown = {
    hidden: { opacity: 1, y: 0 },
    visible: { opacity: 1, y: 0, transition: { duration: 0 } }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const inputStyle = {
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    background: "#f8f9fb",
    outline: "none",
    fontSize: "14px"
  };

  const options = [
    { value: "company", label: "Company Registration" },
    { value: "gst", label: "GST Compliance" },
    { value: "trademark", label: "Trademark Support" }
  ];

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      className="contact-wrapper contact-page"
      style={{ paddingTop: "20px" }}
    >
      {/* HEADING SECTION */}
      <motion.div
        variants={fadeInDown}
        className="heading-section contact-heading"
        style={{
    textAlign: "center",
    marginBottom: "60px",
    padding: "0 40px",
    position: "relative",   // ✅ ADD
    zIndex: 10              // ✅ ADD
  }}
      >
        <h2 style={{ fontSize: "34px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}>
          Contact Us
        </h2>
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "15px"
    }}>
      <div style={{ width: "40px", height: "3px", backgroundColor: "#94a3b8" }}></div>
      <div style={{ width: "60px", height: "12px", backgroundColor: "#0f2b46" }}></div>
      <div style={{ width: "40px", height: "3px", backgroundColor: "#94a3b8" }}></div>
    </div>

      </motion.div>

      <div className="contact-container">
        <div className="contact-grid" >
          {/* LEFT SIDE - Form Animation */}
          <motion.div variants={staggerContainer} style={{ paddingRight: "30px" }}>
            <motion.h1
              variants={fadeInUp}
              className="contact-title"
              style={{
                fontSize: "30px",
                marginBottom: "15px",
                fontWeight: "700",
                color: "#0f2b46",
                letterSpacing: "0.5px"
              }}
            >
              Get in Touch
            </motion.h1>

           
            
            <div
              className="contact-form"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px"
              }}
            >
              <motion.input variants={fadeInUp} type="text" placeholder="Full Name" style={inputStyle} />
              <motion.input variants={fadeInUp} type="email" placeholder="Email" style={inputStyle} />
              <motion.input variants={fadeInUp} type="text" placeholder="Phone" style={inputStyle} />
              <motion.input variants={fadeInUp} type="text" placeholder="Company" style={inputStyle} />
              <motion.input variants={fadeInUp} type="text" placeholder="Country" style={{ ...inputStyle, gridColumn: "span 2" }} />

              <div style={{ gridColumn: "span 2" }}>
                <Select
                  options={options}
                  placeholder="Select Inquiry Type"
                  styles={{
                    control: (base) => ({
                      ...base,
                      padding: "2px",
                      borderRadius: "10px",
                      border: "1px solid #ddd",
                      background: "#f8f9fb",
                      fontSize: "14px",
                      boxShadow: "none"
                    })
                  }}
                />
              </div>
              <motion.textarea
                variants={fadeInUp}
                placeholder="Your Message"
                style={{
                  gridColumn: "span 2",
                  height: "110px",
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                  background: "#f8f9fb",
                  outline: "none"
                }}
              />
            </div>

            <motion.div
              variants={fadeInUp}
              style={{ marginTop: "10px", display: "flex", alignItems: "center" }}
            >
              <input type="checkbox" id="privacy" />
              <label htmlFor="privacy" style={{ marginLeft: "8px", fontSize: "14px" }}>
                I agree to the Privacy Policy & Terms
              </label>
            </motion.div>

            <motion.button
              variants={fadeInUp}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{
                marginTop: "15px",
                padding: "10px 22px",
                background: "#2563eb",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px"
              }}
            >
              Send Message
            </motion.button>
          </motion.div>

          {/* RIGHT SIDE - Office Info Animation */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="contact-title" style={{ fontSize: "30px", fontWeight: "700", marginBottom: "15px", color: "#0f2b46" }}>Our Office</h1>

            <div
              className="office-card"
              style={{
                padding: "20px",
                backgroundColor: "#0f2b46", // 
                color: "#fff" // 
              }}
            >
              <h3 style={{ marginTop: "0", color: "#fff" }}>
                Manoj V. Ayadi & Associates
              </h3>

              <p>Office No. F-79, First Floor, Haware Fantasia Business Park,</p>
              <p>Near Inorbit Mall, Sector 30A, Vashi,</p>
              <p>Navi Mumbai, Maharashtra - 400703</p>
              <p>Email: office@csmanojayadi.com</p>
              <p>Office: 022-65027026</p>
              <p>Mobile: +91 9773112128</p>
            </div>

            <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}>
              <div
                onClick={() =>
                  window.open(
                    "https://www.google.com/maps/search/?api=1&query=Manoj+V+Ayadi+Associates+Haware+Fantasia+Vashi+Navi+Mumbai",
                    "_blank"
                  )
                }
                style={{ overflow: "hidden", borderRadius: "10px", cursor: "pointer" }}
              >                {/* Fixed unique title for iframe below */}


                <iframe

                  title="Office Location Map"
                  src="https://www.google.com/maps?output=embed&q=Manoj+V+Ayadi+Associates+Haware+Fantasia+Vashi+Navi+Mumbai"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  loading="lazy">
                </iframe>
              </div>
            </motion.div>
          </motion.div>

        </div>
      </div>
    </motion.div>
  );
}

export default Contact;